module.exports = __webpack_public_path__ + "static/img/icon5.f57011f9.png";